/**
 * The Typesense `filter_by` Cmd+K sends for one collection — the ONE definition, used by
 * the browser (client/src/lib/typesense-service.ts) and by the golden-set runner
 * (functions/src/search/goldenRun.ts), so the quality measurement searches exactly as
 * users do (#5609 review). Moved verbatim from the client; the caller validates `orgId`.
 * @param {string} collection Typesense collection name
 * @param {string} orgId the caller's org (already validated)
 * @param {boolean} canViewCandidates may the caller see recruiting candidates (P14)
 * @return {string} filter_by
 */
export function buildContactsAwareFilter(
  collection: string,
  orgId: string,
  canViewCandidates: boolean,
): string {
  // Assets uses the orgId field instead of organizationId.
  // Backtick-quote values for consistent Typesense filter syntax.
  const base =
    collection === "assets"
      ? `orgId:=\`${orgId}\``
      : `organizationId:=\`${orgId}\``;

  if (collection === "contacts" && !canViewCandidates) {
    return `${base} && isCandidate:=false`;
  }

  // Customers deleted in QuickBooks must not appear in search. POSITIVE for the
  // same reason isCandidate is: Typesense drops field-absent documents from a
  // filter, so a negation would hide every customer whose payload lacked the
  // field. The indexer therefore always writes `active` (sync-handlers.ts).
  if (collection === "qbo_customers") {
    return base + " && active:=" + "`true`";
  }
  return base;
}

/** The ranking parameters Cmd+K sends with every open-collection search. */
export const CMDK_SEARCH_OPTIONS = Object.freeze({
  sort_by: "_text_match:desc,createdAt:desc",
  num_typos: 1,
  prefix: true,
});
